import { render, staticRenderFns } from "./consultManageType.vue?vue&type=template&id=4b994abc&scoped=true&"
import script from "./consultManageType.vue?vue&type=script&lang=js&"
export * from "./consultManageType.vue?vue&type=script&lang=js&"
import style0 from "./consultManageType.vue?vue&type=style&index=0&id=4b994abc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b994abc",
  null
  
)

export default component.exports